import { GraphNavAdapter } from "../../../../../graphics/graph-nav-adapter";

export class measurerGraphNavAdapter extends GraphNavAdapter {
    areaRect;
    hoverRect;

    setupRectangles = async () => {
        const contentGroups = this.chartProvider.charts;

        contentGroups.forEach((item, index) => {
            const rectContentGroup = item.findContentGroup("rectangle");
            if (rectContentGroup !== undefined) {
                const rectGroup = rectContentGroup;
                const area = rectGroup.findByName("area");
                const hover = rectGroup.findByName("hovered");

                this.areaRect = area;
                this.hoverRect = hover;
            }
        });
    };

    moveSelectRectangle = async (x, width) => {
        await Promise.all([
            this.hoverRect.move(this.valueConverter.convertPointsToPixels(x, this.fd)),
            this.hoverRect.resize(this.valueConverter.convertPointsToPixels(width, this.fd))
        ]);
    };

    moveAreaRectangle = async (x, width) => {
        await Promise.all([
            this.areaRect.move(this.valueConverter.convertPointsToPixels(x, this.fd)),
            this.areaRect.resize(this.valueConverter.convertPointsToPixels(width, this.fd))
        ]);
    };
}
